import React, { useState, useEffect } from 'react';
import Confetti from 'react-confetti';
import { motion } from 'framer-motion';
import * as LucideIcons from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Celebration = ({ winner, onComplete, onShare }) => {
    const { t } = useTranslation();
    const [dimensions, setDimensions] = useState({ width: window.innerWidth, height: window.innerHeight });
    const [isFadingOut, setIsFadingOut] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setDimensions({ width: window.innerWidth, height: window.innerHeight });
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleClose = () => {
        setIsFadingOut(true);
        setTimeout(onComplete, 500); // Match fade-out duration
    };

    if (!winner) return null;

    return (
        <motion.div 
            className="fixed inset-0 bg-black bg-opacity-90 backdrop-blur-md flex flex-col items-center justify-center z-50"
            initial={{ opacity: 0 }}
            animate={{ opacity: isFadingOut ? 0 : 1 }}
            transition={{ duration: 0.5 }}
        >
            <Confetti
                width={dimensions.width}
                height={dimensions.height}
                numberOfPieces={isFadingOut ? 0 : 400}
                recycle={false}
                gravity={0.15}
                onConfettiComplete={() => {}}
            />
            <motion.div 
                className="text-center p-8 bg-gray-900/80 rounded-xl border-2 border-yellow-500 shadow-2xl shadow-yellow-500/30"
                initial={{ scale: 0.5, opacity: 0 }}
                animate={{ scale: 1, opacity: 1, transition: { delay: 0.3, type: 'spring', stiffness: 150 } }}
            >
                <LucideIcons.Crown size={64} className="text-yellow-400 mx-auto mb-4 animate-bounce" />
                <h3 className="text-4xl md:text-5xl font-bold text-yellow-300 mb-2 animate-shimmer bg-clip-text text-transparent bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-200 bg-200% bg-pos-0 hover:bg-pos-100 transition-all duration-5000 ease-linear">
                    {winner.prizeAmount >= 10000 ? t('celebration.grandJackpot') : t('celebration.winnerTitle')}
                </h3>
                <p className="text-2xl text-white mt-4 mb-2">{t('celebration.congratulations', { displayName: winner.displayName || winner.winnerId.substring(0, 8) + '...' })}</p>
                <p className="text-3xl text-green-400 font-bold">{t('celebration.prizeMessage', { amount: winner.prizeAmount.toLocaleString() })}</p>
                
                <div className="flex gap-4 mt-8">
                    <button onClick={onShare} className="flex-1 px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-full transition-all transform hover:scale-105 shadow-lg">
                        <LucideIcons.Share2 size={16} className="inline mr-2"/>
                        {t('celebration.share')}
                    </button>
                    <button onClick={handleClose} className="flex-1 px-6 py-3 bg-purple-600 hover:bg-purple-700 text-white font-bold rounded-full transition-all transform hover:scale-105 shadow-lg">
                        {t('celebration.awesome')}
                    </button>
                </div>
            </motion.div>
        </motion.div>
    );
};

export default Celebration;
